<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="Basic-Paragraph para-style-override-4"><br/></p>
<p class="Basic-Paragraph para-style-override-4"><br/></p>
<div class="frame-2" style="text-align: center;"><img alt="Confederacy%27s%20First%20Battle%20Flag%20No%20Author.jpg" class="frame-3" src="Images/Confederacy%27s%20First%20B_fmt3.jpeg"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HalfTitle2.vue?34c28b9b